module.exports = __webpack_public_path__ + "img/doctor_secondary.0ec7f8f7.svg";